import { render, staticRenderFns } from "./loaders.vue?vue&type=template&id=d1790c72&"
import script from "./loaders.vue?vue&type=script&lang=js&"
export * from "./loaders.vue?vue&type=script&lang=js&"
import style0 from "./loaders.vue?vue&type=style&index=0&id=d1790c72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports